module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/en_2-bb79e05512d932a29d0d25373d937d59.jpg";